import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "b-limited-edit-popup" }
const _hoisted_2 = { class: "b-limited-edit-popup__inner" }
const _hoisted_3 = { class: "h-font-18 h-fw-500 h-text-center h-m-0" }
const _hoisted_4 = {
  key: 0,
  class: "h-font-14 h-fw-400 h-text-center h-mt-20"
}
const _hoisted_5 = {
  key: 1,
  class: "h-font-14 h-fw-400 h-text-center h-mt-20"
}
const _hoisted_6 = { class: "h-flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FwIcon, {
        class: "b-limited-edit-popup__inner__icon",
        icon: "close",
        size: "15",
        color: "#BEC7D4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('POPUP.EDIT.EVENT.LIMITED.TITLE')), 1),
      (_ctx.isRoomsAvailableText && _ctx.user.kind === `advisor`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('POPUP.EDIT.EVENT.LIMITED.ASIDE.ROOM')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('POPUP.EDIT.EVENT.LIMITED.ASIDE')), 1)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FwButton, {
          class: "h-mt-30",
          borderRadiusType: "small-border",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("goToEdit")))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('POPUP.EDIT.EVENT.LIMITED.BUTTON')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}